// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cbu: CountryValidator<"AR"> = createValidator(
  "ar.cbu",
  5,
);

export default cbu;
export const compact = cbu.compact;
export const format = cbu.format;
export const validate = cbu.validate;
export const generate = (): string =>
  cbu.generate?.() ??
  (() => {
    throw new Error(
      "Validator ar.cbu cannot generate values",
    );
  })();
